import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import SuccessConfirmationModal from '../../SuccessConfirmationModal';

const PluginClientAddingConfirmationModal = ({
    pluginId,
    pluginName,
    pluginConfiguration,
    notes = '',
    toggle,
    isOpen = false,
    refreshManifest,
    resetConfig,
}) => {
    const dispatch = useDispatch();

    const [adding, setadding] = useState(false);
    const [isSuccessComfirmationModalOpen, setIsSuccessComfirmationModalOpen] =
        useState(false);
    const [addPluginResponse, setAddPluginResponse] = useState();

    const instanceId = useSelector(
        (state) => state.practice?.practice?.instanceId
    );

    const close = useCallback(() => {
        toggle();
    }, [toggle]);

    const submit = async () => {
        setadding(true);
        dispatch(
            actions.clientPlugins.addClientPlugin(instanceId, {
                pluginId: pluginId,
                pluginVersion: pluginConfiguration.pluginVersion,
                status: pluginConfiguration.targetState,
                notes: notes !== '' ? notes : null,
            })
        )
            .then((res) => {
                setadding(false);
                setAddPluginResponse(res);
                refreshManifest();
                if (res.isSuccess) {
                    resetConfig();
                }
                close();
            })
            .then(() => setIsSuccessComfirmationModalOpen(true));
    };

    const successConfirmationModalCloseBehavior = () => {
        setIsSuccessComfirmationModalOpen(false);
    };

    return (
        <>
            <SuccessConfirmationModal
                isOpen={isSuccessComfirmationModalOpen}
                successResponse={addPluginResponse}
                closeBehavior={() => setIsSuccessComfirmationModalOpen(false)}
            />
            <Modal
                className="text-light"
                style={{ minWidth: '35vw' }}
                centered
                isOpen={isOpen}
                toggle={close}>
                <ModalHeader>
                    <span>
                        <FontAwesomeIcon
                            size="lg"
                            color="yellow"
                            icon={faExclamationTriangle}
                        />
                        &nbsp; Confirm add plugin?
                    </span>
                </ModalHeader>
                <ModalBody>
                    <Row className="my-2">
                        <Col xs="12" md="12" lg="12">
                            <div>
                                <div>{pluginName}</div>
                                <div className="text-14 op-7">
                                    Plugin Id: {pluginId}
                                </div>
                                <div key={pluginConfiguration?.pluginId}>
                                    <div>
                                        Plugin Version:{' '}
                                        {pluginConfiguration?.pluginVersion}
                                    </div>
                                    <div>
                                        Target State:{' '}
                                        {pluginConfiguration?.targetState
                                            .isCached
                                            ? 'cached'
                                            : 'not cached'}
                                        ,{' '}
                                        {pluginConfiguration?.targetState
                                            .isInstalled
                                            ? 'installed'
                                            : 'not installed'}
                                        ,{' '}
                                        {pluginConfiguration?.targetState
                                            .isRunning
                                            ? 'running'
                                            : 'not running'}
                                    </div>
                                </div>
                                <div>Note: {notes}</div>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="danger"
                        className="border"
                        onClick={close}
                        disabled={adding}>
                        Cancel
                    </Button>
                    <Button
                        color={adding ? 'secondary' : 'success'}
                        className="border"
                        onClick={() => submit()}
                        disabled={adding}>
                        {adding ? 'Adding...' : 'Confirm'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default PluginClientAddingConfirmationModal;
